import React from 'react';
import clx from 'classnames';
import { HashLink } from 'react-router-hash-link';
import { hrefIsExternal } from 'client/utils';

import styles from './Link.module.scss';

interface LinkProps {
    icon?: string;
    external?: boolean;
    to?: string;
    isCurrentPath: boolean;
}

export default function Link(props: LinkProps & React.HTMLProps<HTMLAnchorElement>) {
    const { icon, isCurrentPath, external, to, children, ...rest } = props;
    const style = { backgroundImage: '' };
    if (icon) {
        style.backgroundImage = 'url(' + icon + ')';
    }

    if (typeof to === 'string' && (external || hrefIsExternal.test(to))) {
        return (
            <a href={to} rel="noopener noreferrer" {...rest}>
                {icon && <div style={style} />}
                {children}
            </a>
        );
    }

    return (
        <HashLink className={clx(styles.menuLink, isCurrentPath && styles.menuLink_active)} smooth to={to || '/'}>
            {icon && <div style={style} />}
            {children}
        </HashLink>
    );
}
